import { render } from "./HospitalLogout.vue?vue&type=template&id=e1f014e0&ts=true"
import script from "./HospitalLogout.vue?vue&type=script&lang=ts"
export * from "./HospitalLogout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__